/**
 * Access to the API (obsessless-api) from outside db-admin. For now, the tokens that let
 * Claude Code read eval runs through the evals MCP server.
 */
import { ApiTokensPanel } from './components/ApiTokensPanel';

export const Api = () => (
  <div className="min-h-screen bg-gray-50">
    <div className="max-w-7xl mx-auto p-4 sm:p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 mb-1">Api</h1>
        <p className="text-sm text-gray-500">Tokens for tools that use the API without a db-admin sign-in.</p>
      </div>
      <ApiTokensPanel />
    </div>
  </div>
);
